module.exports = __webpack_public_path__ + "static/media/logo.d5b815e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFoundPage/logo.jpg
// module id = 131
// module chunks = 0